import { Content } from "./content/content";
import { Icon } from "./icon/icon";
import { Root } from "./root/root";
import { Title } from "./title/title";

const Alert = Root as typeof Root & {
    Icon: typeof Icon;
    Content: typeof Content;
    Title: typeof Title;
};

Alert.Content = Content;
Alert.Icon = Icon;
Alert.Title = Title;

export { Alert };
export type { Severity as AlertSeverity } from "./types";
export type { RootProps as AlertProps } from "./root/root";
export type { ContentProps as AlertContentProps } from "./content/content";
export type { IconProps as AlertIconProps } from "./icon/icon";
export type { TitleProps as AlertTitleProps } from "./title/title";
